import { Injectable } from '@angular/core';

@Injectable()
export class GaService {

  enable: boolean = false;
  gaId: string;
  
  constructor(
  ) {
  }

  init(gaId: string){
    this.gaId = gaId;

    const bodyTag = document.getElementsByTagName('body').item(0);

    const scriptTag1 = document.createElement('script');
    scriptTag1.src = 'https://www.googletagmanager.com/gtag/js?id=' + gaId;
    scriptTag1.setAttribute("async", "");
    bodyTag.appendChild(scriptTag1);

    const scriptTag2 = document.createElement('script');
    const scriptTag2InnerHtml = "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', '" + gaId + "');";
    scriptTag2.innerHTML = scriptTag2InnerHtml;
    bodyTag.appendChild(scriptTag2);

    this.enable = true;
  }

  videoLoad(data){
    // console.log("videoLoad");
    gtag('event', 'video_load', {
      video_duration: data.duration,
      video_provider: '1ROLL',
      video_title: data.title,
      video_url: document.referrer,
      video_id: data.videoId,
    });
  }

  videoProgress(data){
    // console.log("videoProgress");
    gtag('event', 'video_progress', {
      video_current_time: data.currentTime,
      video_duration: data.duration,
      video_percent: data.percent,
      video_provider: '1ROLL',
      video_title: data.title,
      video_url: document.referrer,
      video_id: data.videoId,
    });
  }


}

